export default __webpack_public_path__ + "static/media/spiral.1717ca4a.svg";